import { Outlet, Navigate } from "@tanstack/react-router";
import { useSession } from "@/frontend/auth-client";
import { Loader2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { orpc } from "@/frontend/orpc-client";
import { SidebarProvider } from "@/frontend/components/ui/sidebar";
import { AppSidebar, SidebarInset } from "./AppSidebar";
import { TooltipProvider } from "@/frontend/components/ui/tooltip";

export function DashboardLayout() {
  const { data: session, isPending } = useSession();
  const isPlatformAdmin = session?.user?.role === "admin";
  const actorContextQuery = useQuery({
    ...orpc.org.getActorContext.queryOptions({ input: {} }),
    enabled: !!session,
  });

  const activeMemberQuery = useQuery({
    ...orpc.org.getActiveMember.queryOptions({ input: {} }),
    enabled: !!session && !isPlatformAdmin,
  });
  const hasOrgAccess =
    isPlatformAdmin ||
    (actorContextQuery.data?.actorType === "orgMember" && !!activeMemberQuery.data);

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/" />;
  }

  if (actorContextQuery.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (actorContextQuery.data?.actorType === "patient") {
    return <Navigate to="/" />;
  }

  if (!hasOrgAccess && activeMemberQuery.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!hasOrgAccess) {
    return <Navigate to="/" />;
  }

  return (
    <TooltipProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  );
}
